angular.module('leanlaw').directive('llTabs', [function () {
  return {
    restrict: 'AE',
    template: require("./views/tabs.html"),
    scope: {
      tabs: '=',
      module: '='
    }
  };
}]);